import * as React from "react";

import PosConsoleApi from "app/utils/PosConsoleApi";
import Select from "react-select";

export default class Overview extends React.Component<any, {}> {
  state = {
    isLoading: true,
    providers: [],
    selectedProviders: null,
    options: [],
    message: ""
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Electricity > Overview",
      description: "Electricity Provider Overview"
    });

    PosConsoleApi.get("electricity/status")
      .then(response => response.json())
      .then(({ available_providers, providers }) => {
        this.setState({
          providers,
          selectedProviders: providers.map(v => ({ value: v, label: v })),
          isLoading: false,
          options: available_providers.map(v => ({ value: v, label: v }))
        });
      });
  }
  handleChange = selectedProviders => {
    this.setState({ selectedProviders: selectedProviders });
  };
  updateProviders = () => {
    const { selectedProviders } = this.state;
    this.setState({
      message: "Updating.."
    });

    PosConsoleApi.post("electricity/providers", {
      providers: selectedProviders.map(v => v.value)
    })
      .then(response => response.json())
      .then(() => {
        this.setState({
          message: "Providers updated successfully"
        });
      })
      .catch(() => {
        this.setState({
          message: "Unable to update providers, please try again."
        });
      });
  };
  render() {
    const { isLoading, selectedProviders, options, message } = this.state;
    return (
      <section className="padded">
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div>
              <h2>Enabled Providers</h2>
              <p>Highest to lowest priority</p>
              <Select
                value={selectedProviders}
                isMulti="1"
                placeholder="Electricity Providers"
                onChange={this.handleChange}
                options={options}
              />
              <button
                className="button no-margin updateElectricityProviderButton"
                onClick={this.updateProviders}
              >
                Update
              </button>
              <p>{message}</p>
            </div>
          </>
        )}
      </section>
    );
  }
}
